<div class="dc-modal error" [ngClass]="size">
  <div class="dc-modal__header">
    <h2 class="dc-modal__title">{{ title }}</h2>
    <span class="dc-modal__close" #focusElement (click)="close()"></span>
  </div>
  <div class="dc-modal__body">
    <div>
      {{errorMessage}}
    </div>
    <ul>
      <li *ngFor="let error of formattedErrors">
        {{error}}
      </li>
    </ul>
  </div>
  <div class="dc-modal__footer">
      <button
        *ngFor="let button of buttons"
        (click)="onClick(button)"
        class="{{button.role}}">
        {{ button.text }}
      </button>
  </div>
</div>
